<template>
  <div class="finance">
    <app-cells><h1 class="title">Invoice analytics</h1></app-cells>
    <app-cells>
      <h2 class="title">Estimated income</h2>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="next60Days"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
    </app-cells>
    <div class="finance__holder">
      <app-spinner v-if="!is_loaded" />
      <template v-else>
        <div class="info-row">
          <div v-for="item of total_cards" :key="item.name" class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ item.value.toLocaleString() }} USD</span>
              <span class="info-row__text">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="charts-grid">
          <highcharts :options="graph_options" />
        </div>
        <div class="info-row">
          <div v-for="item of total_cards_services" :key="item.name" class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ item.value.toLocaleString() }} USD</span>
              <span class="info-row__text">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="charts-grid">
          <highcharts :options="graph__services_options" />
        </div>
      </template>
    </div>
    <app-cells>
      <h2 class="title">Payments</h2>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates_payments"
          :custom-shortcuts="custom_shortcuts_payments"
          shortcut="last60Days"
          @is-hidden="onIsHiddenPickerPayments"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error_payments" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
    </app-cells>
    <div class="finance__holder">
      <app-spinner v-if="!is_loaded" />
      <template v-else>
        <div class="info-row">
          <div v-for="item of total_cards_payment_methods" :key="item.name" class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ item.value.toLocaleString() }} USD</span>
              <span class="info-row__text">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="charts-grid">
          <highcharts :options="graph__payment_methods_options" />
        </div>
        <div class="info-row">
          <div v-for="item of total_cards_payment_services" :key="item.name" class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ item.value.toLocaleString() }} USD</span>
              <span class="info-row__text">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="charts-grid">
          <highcharts :options="graph__payment_services_options" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Chart } from 'highcharts-vue'
import moment from 'moment/moment'
import {
  getFinanceAnalyticsEstimatedAccounts,
  getFinanceAnalyticsEstimatedServices,
  getFinanceAnalyticsPaymentMethods,
  getFinanceAnalyticsPaymentServices
} from '@/http'

export default {
  name: 'FinanceAnalytics',
  components: { VueCtkDateTimePicker, highcharts: Chart },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      filter_dates_payments: null,
      date_picker_error: false,
      date_picker_error_payments: false,
      custom_shortcuts: [
        {
          key: 'next30Days',
          label: 'Next 30 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(30, 'days')
            }
          }
        },
        {
          key: 'next60Days',
          label: 'Next 60 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(60, 'days')
            }
          }
        },
        {
          key: 'next90Days',
          label: 'Next 90 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(90, 'days')
            }
          }
        },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
      graph_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph__services_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph__payment_methods_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph__payment_services_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      total_cards: [],
      total_cards_services: [],
      total_cards_payment_methods: [],
      total_cards_payment_services: [],
      custom_shortcuts_payments: [
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
    }
  },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        Promise.all([
          this.fetchGraph(),
          this.fetchGraphServices(),
          this.fetchGraphPaymentMethods(),
          this.fetchGraphPaymentServices()
        ]).then(() => { this.is_loaded = true })
      })
    }, 0)
  },
  methods: {
    fetchGraphsEstimated() {
      this.fetchGraph()
      this.fetchGraphServices()
    },
    fetchGraphsPayments() {
      this.fetchGraphPaymentMethods()
      this.fetchGraphPaymentServices()
    },
    async fetchGraph() {
      const response = await getFinanceAnalyticsEstimatedAccounts({from_date: this.filter_dates.start, to_date: this.filter_dates.end})
      this.graph_options.xAxis.categories = response.data.instances.categories
      this.graph_options.series = response.data.instances.series
      this.total_cards = response.data.total
    },
    async fetchGraphServices() {
      const response = await getFinanceAnalyticsEstimatedServices({from_date: this.filter_dates.start, to_date: this.filter_dates.end})
      this.graph__services_options.xAxis.categories = response.data.instances.categories
      this.graph__services_options.series = response.data.instances.series
      this.total_cards_services = response.data.total
    },
    async fetchGraphPaymentMethods() {
      const response = await getFinanceAnalyticsPaymentMethods({from_date: this.filter_dates_payments.start, to_date: this.filter_dates_payments.end})
      this.graph__payment_methods_options.xAxis.categories = response.data.instances.categories
      this.graph__payment_methods_options.series = response.data.instances.series
      this.total_cards_payment_methods = response.data.total
    },
    async fetchGraphPaymentServices() {
      const response = await getFinanceAnalyticsPaymentServices({from_date: this.filter_dates_payments.start, to_date: this.filter_dates_payments.end})
      this.graph__payment_services_options.xAxis.categories = response.data.instances.categories
      this.graph__payment_services_options.series = response.data.instances.series
      this.total_cards_payment_services = response.data.total
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchGraphsEstimated()
      } else this.date_picker_error = true
    },
    onIsHiddenPickerPayments() {
      if (this.filter_dates_payments?.start && this.filter_dates_payments?.end) {
        this.date_picker_error_payments = false
        this.fetchGraphsPayments()
      } else this.date_picker_error_payments = true
    },
  }
}
</script>

<style lang="sass" scoped>
.finance__holder
  position: relative
  min-height: 300px
</style>
